/**
 * An overlap in a table row (Feature 74 D5): on the platform, the kind of
 * template it overlaps, short enough for a column, the record panel naming
 * it (D11); in an organization, the automation itself, since there is one to
 * turn off. A dash when there is none.
 */
import { Badge } from '../../ui/finixt.js';
import { describe, type Automation } from './overlaps.js';

export function OverlapBadge({
  others,
  templates,
}: {
  others: readonly Automation[];
  /** On the platform, "template" follows the kind. */
  templates: boolean;
}) {
  const [first] = others;
  if (!first) return <span style={{ color: 'var(--text-faint)' }}>—</span>;
  const more = others.length - 1;
  const label = templates
    ? more > 0
      ? `${others.length} templates`
      : 'a linkage template'
    : `overlaps ${describe(first, false)}${more > 0 ? ` +${more}` : ''}`;
  return (
    <span title={others.map((o) => describe(o, templates)).join(', ')}>
      <Badge tone="warn">{label}</Badge>
    </span>
  );
}
